module.exports = require('./build/callapp');



//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alife_callapp@1.0.8@@alife/callapp/index.js
// module id = 230
// module chunks = 0